import React from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../../assets/images/logo.png'

const TAGS = [
  'Unbegrenzte Analysen',
  'Rendite-Berechnung',
  'Marktpreis-Vergleich',
  'Risiko-Erkennung',
]

export default function SubscriptionSuccess() {
  const navigate = useNavigate()

  return (
    <div style={styles.wrapper}>

      <h1 style={styles.headline}>Willkommen im Pro-Plan!</h1>
      <p style={styles.bodyText}>
        Dein Upgrade war erfolgreich.
        <span style={styles.bodyTextSub}>14,99 €/Monat · Jederzeit kündbar</span>
      </p>

      {/* Visual */}
      <div style={styles.visual}>
        <div style={styles.scorecard}>

          {/* Logo */}
          <div style={styles.scorecardLogo}>
            <img src={logo} alt="ImmoSight" height={20} />
          </div>

          {/* Body */}
          <div style={styles.scorecardBody}>

            {/* Gauge */}
            <div style={styles.gaugeWrap}>
              <div style={styles.gauge}>
                <svg width="68" height="68" viewBox="0 0 68 68" style={{ transform: 'rotate(-90deg)' }}>
                  <circle cx="34" cy="34" r="28" fill="none" stroke="#E8F7F7" strokeWidth="7" />
                  <circle
                    cx="34" cy="34" r="28"
                    fill="none"
                    stroke="#1DB3B3"
                    strokeWidth="7"
                    strokeLinecap="round"
                    strokeDasharray="176"
                    strokeDashoffset="0"
                    style={{ animation: 'gaugeAnim 1s ease both 0.3s' }}
                  />
                </svg>
                <div style={styles.gaugeNumber}>100</div>
              </div>
              <span style={styles.gaugeLabel}>Schnellanalyse</span>
            </div>

            {/* Info */}
            <div style={styles.scorecardInfo}>
              <div style={styles.scorecardVerdict}>Pro aktiviert</div>
              <div style={styles.scorecardTags}>
                {TAGS.map((tag, i) => (
                  <span
                    key={tag}
                    style={{
                      ...styles.tag,
                      animation: `tagIn 0.4s ease both ${0.4 + i * 0.15}s`,
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

          </div>
        </div>

        <span style={styles.visualHint}>Alle Pro-Features sind jetzt freigeschaltet</span>
      </div>

      <button
        style={styles.button}
        onClick={() => window.location.href = 'https://immolens-dev.realvation.app/properties'}
      >
        Zum Dashboard →
      </button>

      <style>{`
        @keyframes gaugeAnim {
          from { stroke-dashoffset: 176; }
          to   { stroke-dashoffset: 0; }
        }
        @keyframes tagIn {
          from { opacity: 0; transform: scale(0.85); }
          to   { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  )
}

const styles = {
  wrapper: {
    maxWidth: 520,
    margin: '0 auto',
    padding: '52px 24px 80px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  },
  headline: {
    fontSize: 26,
    fontWeight: 700,
    color: '#0F172A',
    lineHeight: 1.3,
    textAlign: 'center',
    marginBottom: 10,
    width: '100%',
  },
  bodyText: {
    fontSize: 15,
    fontWeight: 400,
    color: '#64748B',
    lineHeight: 1.6,
    textAlign: 'center',
    marginBottom: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  bodyTextSub: {
    color: '#94A3B8',
    fontSize: 13,
  },
  visual: {
    width: '100%',
    background: '#F0FAFA',
    borderRadius: 12,
    border: '1px solid #E2E8F0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 28,
    padding: '24px 24px 16px',
    gap: 12,
    overflow: 'hidden',
  },
  scorecard: {
    background: '#fff',
    borderRadius: 12,
    border: '1px solid #E2E8F0',
    padding: '14px 16px',
    width: '100%',
    maxWidth: 360,
    boxShadow: '0 4px 20px rgba(29,179,179,0.10)',
    animation: 'cardIn 0.5s ease both',
  },
  scorecardLogo: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 14,
  },
  scorecardBody: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  gaugeWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
  },
  gauge: {
    position: 'relative',
    width: 68,
    height: 68,
  },
  gaugeNumber: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    fontWeight: 800,
    color: '#0F172A',
  },
  gaugeLabel: {
    fontSize: 10,
    fontWeight: 500,
    color: '#94A3B8',
    textAlign: 'center',
  },
  scorecardInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    flex: 1,
  },
  scorecardVerdict: {
    fontSize: 15,
    fontWeight: 700,
    color: '#0F172A',
  },
  scorecardTags: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
  },
  tag: {
    fontSize: 11,
    fontWeight: 500,
    color: '#0E7A6B',
    background: '#E8F7F7',
    padding: '3px 9px',
    borderRadius: 20,
  },
  visualHint: {
    fontSize: 12,
    color: '#94A3B8',
    textAlign: 'center',
    paddingBottom: 4,
  },
  button: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    padding: '15px 24px',
    background: '#1DB3B3',
    color: '#fff',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    borderRadius: 8,
    border: 'none',
    cursor: 'pointer',
    lineHeight: 1.4,
  },
}
